/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ShadowDecisionEnum = {
    Admit: 'ADMIT',
    Reject: 'REJECT',
    NeedsReview: 'NEEDS_REVIEW'
} as const;
export type ShadowDecisionEnum = typeof ShadowDecisionEnum[keyof typeof ShadowDecisionEnum];


export function ShadowDecisionEnumFromJSON(json: any): ShadowDecisionEnum {
    return ShadowDecisionEnumFromJSONTyped(json, false);
}

export function ShadowDecisionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowDecisionEnum {
    return json as ShadowDecisionEnum;
}

export function ShadowDecisionEnumToJSON(value?: ShadowDecisionEnum | null): any {
    return value as any;
}

